import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import IconMenu from "../assets/images/icon-menu.svg";

const MenuContainer = styled.nav`
  position: relative;

  @media (max-width: 576px) {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
  }
`;

const MenuIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 576px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const BalloonMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 60px;
  right: 0;
  width: 200px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  padding: ${({ isOpen }) => (isOpen ? "15px" : "0")};
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  transition: all 0.3s ease-in-out;
`;

const MenuItem = styled(Link)`
  display: block;
  padding: 10px;
  color: #000;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  &:hover {
    background-color: #f1f1f1;
    border-radius: 5px;
  }
`;

const MenuMobile: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MenuContainer>
      <MenuIcon onClick={() => setIsOpen(!isOpen)}>
        <img src={IconMenu} width={"30px"} />
      </MenuIcon>
      <BalloonMenu isOpen={isOpen}>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
          }}
          to={"/#section-1"}
        >
          Home
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
          }}
          to={"/#section-2"}
        >
          Como funciona
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
          }}
          to={"/#section-3"}
        >
          Quanto custa
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
          }}
          to={"/#section-4"}
        >
          Fale conosco
        </MenuItem>
      </BalloonMenu>
    </MenuContainer>
  );
};

export default MenuMobile;
